var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43415 9.43375H6.28059C6.43889 9.43375 6.56722 9.56208 6.56722 9.72039V14.5668C6.56722 15.3583 7.20888 16 8.0004 16C8.79192 16 9.43358 15.3583 9.43358 14.5668V9.72039C9.43358 9.56208 9.56191 9.43375 9.72021 9.43375H14.5666C15.3582 9.43375 15.9998 8.7921 15.9998 8.00057C15.9998 7.20905 15.3582 6.5674 14.5666 6.5674H9.72021C9.56191 6.5674 9.43358 6.43906 9.43358 6.28076V1.43318C9.43358 0.641656 8.79192 0 8.0004 0C7.20888 0 6.56722 0.641656 6.56722 1.43318V6.28076C6.56722 6.43906 6.43889 6.5674 6.28059 6.5674H1.43415C0.642632 6.5674 0.000976562 7.20905 0.000976562 8.00057C0.000976562 8.7921 0.642632 9.43375 1.43415 9.43375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.cbbcb757236d7eed9ef7cd09cbb2d0bf.svg";
export { ForwardRef as ReactComponent };